import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UsersListComponent } from './users-list/users-list.component';
import { UsersDetailComponent } from './users-detail/users-detail.component';
import { UsersApiUsageComponent } from './users-api-usage/users-api-usage.component';

const routes: Routes = [
  {
    path: 'users',
    children: [
      { path: '', component: UsersListComponent },
      //antes de ':guid' para que quede claro que es más específica, aunque ':guid' no tenga hijos y solo
      //case con un segmento
      { path: ':guid/apiUsage', component: UsersApiUsageComponent, data: { shouldReuse: false } },
      { path: ':guid', component: UsersDetailComponent, data: { shouldReuse: false } }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UsersRoutingModule { }
